class ChooseOptionsTray {
  constructor() {
    this.chooseOptionsBtns = document.querySelectorAll("modal-opener");
    this.mainContent = document.querySelector("#MainContent");
    this.chooseOptionsTrayMarkup = null;
    this.productData = null;
    this.isTrayOpen = false;
    this.eventListeners = [];

    document.addEventListener("click", (event) => {
      if (
        this.isTrayOpen &&
        !event.target.closest("#cl-choose-options-tray") &&
        !event.target.closest("modal-opener")
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.animateChooseOptionsTrayClosing();
      }
    });

    // attach event listener to document so that pressing the escape key will close the tray
    document.addEventListener("keydown", (event) => {
      if (this.isTrayOpen && event.key === "Escape") {
        this.animateChooseOptionsTrayClosing();
      }
    });
  }

  init() {
    this.attachEventListeners();
    this.mainContent.style.transition = "filter 0.2s ease-in-out";
  }

  attachEventListeners() {
    this.detachEventListeners();
    this.chooseOptionsBtns.forEach((btn) => {
      btn.addEventListener("click", this.handleChooseOptionsBtns);
      this.eventListeners.push({
        target: btn,
        type: "click",
        listener: this.handleChooseOptionsBtns,
      });
    });
  }

  detachEventListeners() {
    this.eventListeners.forEach(({ target, type, listener }) => {
      target.removeEventListener(type, listener);
    });

    this.eventListeners = [];
  }

  attachCloseChooseOptionsTrayEventListeners() {
    // close button
    const closeChooseOptionsTrayBtn = document.querySelector(
      "#cl-choose-options-tray-header svg",
    );
    closeChooseOptionsTrayBtn.addEventListener("click", () =>
      this.animateChooseOptionsTrayClosing(),
    );

    // add to cart buttons
    const addToCartBtns = document.querySelectorAll(".cl-add-to-cart-btn");

    addToCartBtns.forEach((btn) => {
      btn.addEventListener("click", this.handleAddToCart);
    });
  }

  generateChooseOptionsTrayMarkup() {
    return `
      <div
        id="cl-choose-options-tray"
        class="
          tw-rounded-t-[20px]
          tw-fixed
          tw-bottom-0
          tw-z-50
          tw-translate-y-full
          tw-w-full
          tw-bg-white
          tw-transition-all
          tw-duration-500
          tw-gap-[30px]
          tw-flex
          tw-flex-col
          tw-justify-between
          tw-max-w-screen-xl
          tw-mx-auto
          tw-right-0
          tw-left-0
        "
        style="filter: drop-shadow(0px -20px 40px rgba(0, 0, 0, 0.5));"
      >
        <div id="cl-choose-options-tray-header" class="tw-px-[20px] tw-pt-[15px] tw-flex tw-justify-between tw-items-center">
          <h4 class="tw-text-[30px] tw-m-0">
            <a href="/products/${this.productData.handle}" class="cl-custom-underline-pseudo-element tw-relative tw-text-black tw-no-underline">
              ${this.productData.title}
            </a>
          </h4>

          <svg class="hover:tw-cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path></svg>
        </div>

        <div>
          <div class="swiper tw-max-w-full">
            <div class="swiper-wrapper">
              ${this.productData.images
                .map((image) => {
                  return `
                  <div class="swiper-slide tw-aspect-square">
                    <img
                      src="${image.src + "&width=500"}"
                      alt="${image.alt ? image.alt : ""}"
                      width="500"
                      height="500"
                      class="
                        tw-w-full
                        tw-object-cover
                        tw-aspect-square
                      "
                    />
                  </div>
                `;
                })
                .join("")}
            </div>

            <div class="swiper-button-prev tw-scale-[0.4]"></div>
            <div class="swiper-button-next tw-scale-[0.4]"></div>
          </div>

          <div>
            <a class="tw-text-black tw-no-underline tw-pt-0 tw-px-[10px] tw-mt-[10px] tw-flex sm:tw-text-[10px] md:tw-text-[11px] lg:tw-text-[12px] xl:tw-text-[13px] tw-items-center hover:tw-underline" href="/products/${this.productData.handle}">
              View Product Details <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path></svg>
            </a>
          </div>
        </div>
      
        <div class="">
          ${this.productData.variants
            .map((variant) => {
              return `
              <div class="tw-flex tw-items-center tw-justify-between tw-border-t tw-border-gray-200 tw-p-8">
                <p class="tw-text-lg tw-font-semibold sm:tw-text-[14px] md:tw-text-[15px] lg:tw-text-[16px] xl:tw-text-[17px]">
                  ${variant.title}<br>
                  <span class="tw-text-sm tw-font-normal tw-text-grey-500 tw-text-[10px] md:tw-text-[11px] lg:tw-text-[12px] xl:tw-text-[13px]">
                    ${variant.sku}
                  </span>
                </p>
                <p class="tw-text-lg tw-font-semibold sm:tw-text-[14px] md:tw-text-[15px] lg:tw-text-[16px] xl:tw-text-[17px]">
                  ${new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active }).format(variant.price)}
                </p>

                <button data-variant-id="${variant.id}" class="tw-cursor-pointer cl-add-to-cart-btn tw-w-[130px] sm:tw-w-[140px] md:tw-w-[150px] lg:tw-w-[160px] tw-transition-all tw-px-5 tw-py-3 tw-bg-black hover:tw-bg-white hover:tw-text-black tw-border-solid tw-border-2 tw-border-black tw-text-white sm:tw-text-[18px] md:tw-text-[19px] lg:tw-text-[20px] xl:tw-text-[21px]">
                  Add to Cart
                </button>
              </div>
            `;
            })
            .join("")}
        </div>
      </div>
    `;
  }

  animateChooseOptionsTrayOpening() {
    document.body.style.overflow = "hidden";
    this.mainContent.style.filter = "blur(1px)";
    const chooseOptionsTray = document.getElementById("cl-choose-options-tray");
    if (chooseOptionsTray) {
      chooseOptionsTray.classList.remove("tw-translate-y-full");
      this.isTrayOpen = true;
    }
  }

  animateChooseOptionsTrayClosing() {
    document.body.style.overflow = "auto";
    this.mainContent.style.filter = "none";
    const chooseOptionsTray = document.getElementById("cl-choose-options-tray");
    if (chooseOptionsTray) {
      chooseOptionsTray.classList.add("tw-translate-y-full");
      this.isTrayOpen = false;

      // remove tray after animation
      setTimeout(() => {
        chooseOptionsTray.remove();
      }, 500);
    }
  }

  updateCartCountBubble() {
    const cartCountBubble = document.querySelector(".cart-count-bubble"); // only exists if items in cart
    const cartIconBubble = document.querySelector("#cart-icon-bubble");

    if (cartCountBubble) {
      const span1 = cartCountBubble.querySelector("span:first-child");
      const span2 = cartCountBubble.querySelector("span:last-child");

      // increment count
      span1.textContent = parseInt(span1.textContent) + 1;
      span2.textContent = `${parseInt(span1.textContent)} items`;
    } else {
      const cartCountBubble = document.createElement("div");
      cartCountBubble.classList.add("cart-count-bubble");

      const span1 = document.createElement("span");
      span1.setAttribute("aria-hidden", "true");
      span1.textContent = "1";

      const span2 = document.createElement("span");
      span2.classList.add("visually-hidden");
      span2.textContent = "1 item";

      cartCountBubble.appendChild(span1);
      cartCountBubble.appendChild(span2);

      cartIconBubble.appendChild(cartCountBubble);
    }

    // Remove all event listeners from cartIconBubble by cloning
    const cartIconBubbleClone = cartIconBubble.cloneNode(true);
    cartIconBubble.parentNode.replaceChild(cartIconBubbleClone, cartIconBubble);

    // NOTE: Similar code to what appears inside the cart.js file
    document.querySelector(".cart-count-bubble").classList.add("tw-transition"); // maybe not neccessary, but want the transition class to be added before scaling
    document.querySelector(".cart-count-bubble").classList.add("tw-scale-125");
    setTimeout(() => {
      document
        .querySelector(".cart-count-bubble")
        .classList.remove("tw-scale-125");
    }, 100);
  }

  renderChooseOptionsTray() {
    this.removeExistingChooseOptionsTray();
    document.body.insertAdjacentHTML("beforeend", this.chooseOptionsTrayMarkup);
    this.attachCloseChooseOptionsTrayEventListeners();
    this.isTrayOpen = true;

    // back button closes tray rather than going back in history
    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", () => {
      this.animateChooseOptionsTrayClosing();
    });

    setTimeout(() => {
      this.animateChooseOptionsTrayOpening();
    }, 100);
  }

  removeExistingChooseOptionsTray() {
    const existingChooseOptionsTray = document.getElementById(
      "cl-choose-options-tray",
    );

    if (existingChooseOptionsTray) {
      existingChooseOptionsTray.remove();
    }
  }

  async fetchProductData(productUrl) {
    productUrl = productUrl.split("?")[0];
    const response = await fetch(`${productUrl}.json`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const { product } = await response.json();
    this.productData = product;
    return this.productData;
  }

  async postToCart(variantId) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    if (!response.ok) {
      alert("Something went wrong. Please try again.");
      return;
    }

    this.updateCartCountBubble();
    return response.json();
  }

  handleAddToCart = async (event) => {
    const variantId = event.target.dataset.variantId;
    event.target.disabled = true;
    event.target.classList.add("tw-opacity-50");
    event.target.textContent = "Adding...";
    await this.postToCart(variantId);
    event.target.textContent = "Added!";
    event.target.disabled = false;
    event.target.classList.remove("tw-opacity-50");
    this.animateChooseOptionsTrayClosing();
  };

  handleChooseOptionsBtns = async (event) => {
    await this.fetchProductData(event.target.dataset.productUrl);
    this.chooseOptionsTrayMarkup = this.generateChooseOptionsTrayMarkup(
      this.productData,
    );
    this.renderChooseOptionsTray();

    // Initialize Swiper
    new Swiper("#cl-choose-options-tray .swiper", {
      a11y: true,
      direction: "horizontal",
      slidesPerView: 1.33,
      loop: true,
      centeredSlides: true,
      spaceBetween: 10,
      grabCursor: true,
      nested: true,
      autoplay: {
        delay: 3000,
      },
      speed: 1000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          spaceBetween: 20,
          centeredSlides: false,
          loop: false,
        },
        992: {
          slidesPerView: 3.5,
          spaceBetween: 30,
          centeredSlides: false,
          loop: false,
        },
      },
    });
  };
}

document.addEventListener("DOMContentLoaded", () => {
  window.chooseOptionsTray = new ChooseOptionsTray();
  window.chooseOptionsTray.init();
});
